// extracted by css-extract-rspack-plugin
export default {"kbd":"GxwEZR76ABgCDzSI","editorFlex":"cgUyd92UTmMZH2DZ","editorWrap":"aM1sMAmCA8fgKpif","editorWrapStretch":"Rp21h_ED7Uua1KBr"};